import zoomSdk from '@zoom/appssdk';

async function configureApp() {
  return await zoomSdk.config({
    popoutSize: { width: 480, height: 360 },
    capabilities: [
      'shareApp',

      // Meeting
      'getMeetingContext',
      'onMeeting',
      'getRunningContext',
      'getMeetingParticipants',
      'getMeetingJoinUrl',
      // App
      'getAppContext',
      'openUrl',
      // authorization
      'authorize',
      'onAuthorized',
      'promptAuthorize',
      'getUserContext',
      'onMyUserContextChange',
    ],
  });
}

export default configureApp;
